import { ACTIONS_TEXT } from 'src/app/components/shared/shared-constants';

export const ColumnIds = {
  ROUTE: 'loop',
  ADL: 'assignedADLs',
  ACTION: 'actions',
};

export const ColumnText = {
  ROUTE: $localize`Route Id`.toUpperCase(),
  ADL: $localize`ASSIGNED ADL`.toUpperCase(),
  ACTIONS: ACTIONS_TEXT,
};

export const DISPLAY_TEXT = {
  WELCOME_TEXT: $localize`Route Admin`,
  MODAL: {
    HEADER: $localize`Remove Route`,
    BODY: $localize`Selected Route ID can't be deleted. All pickups must be unassigned from Route prior to removal.`,
    CONFIRM_BUTTON: $localize`Ok`,
  },
  CONFIRM_MODAL: {
    HEADER: $localize`Alert!`,
    BODY: $localize`Are you sure you want to remove the following Route ID?`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: 'No',
  },
};

export const EXCEL_FILE_NAME = 'route-admin-data';
